import React, { forwardRef } from 'react'
import ReactQuill from 'react-quill'
const RichTextEditor = forwardRef((props, ref) => {

  // ✅ Restrict allowed formats
  const formats = [
    "header",
    "bold", "italic", "underline",
    "list", "bullet",
    "link"
  ]

  // ✅ Restrict toolbar
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"]
    ]
  }

  return (
    <div className="rich-text-editor">
      <ReactQuill
        ref={ref}
        {...props}
        modules={modules}
        formats={formats}
      />
    </div>
  )
})

export default RichTextEditor